import { render, staticRenderFns } from "./OverviewPanel.vue?vue&type=template&id=0fdeefb8&scoped=true"
import script from "./OverviewPanel.vue?vue&type=script&lang=ts"
export * from "./OverviewPanel.vue?vue&type=script&lang=ts"
import style0 from "./OverviewPanel.vue?vue&type=style&index=0&id=0fdeefb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdeefb8",
  null
  
)

export default component.exports